'use strict';
{


    var app = angular.module('tf.portfolio.floatingMenu', [])

        .controller('floatingMenuCtrl', ['$scope', 'userConfig', '$uibModal', function ($scope, userConfig, $uibModal) {

            $scope.styleStressTestMin ="width:'900px';background:red";

            $scope.inviteClient = function (size) {

                var modalInstance = $uibModal.open({

                    templateUrl: 'portfolio/templates/inviteClient/inviteClient.tpl.html',
                    resolve : {
                        userConfig : function () {
                            return userConfig;
                        }
                    },
                    controller: 'ReportAnIssueCtrl',
                    size: size


                });
            };


        } ])


}